import { API_MAP, agent } from 'helpers';

class InvoiceService {
  static loadInvoiceById = (id: any) => agent.get(`${API_MAP.loadInvoiceById}`.replace('{id}', id));
  static listInvoiceStatus = () => agent.get(`${API_MAP.listInvoiceStatus}`);
  static listInvoiceItems = (id: any) => agent.get(`${API_MAP.listInvoiceItems}`.replace('{id}', `${id}`));
  static refundInvoice = (id: any, motive: string) => agent.post(`${API_MAP.refundInvoice}`.replace('{id}', `${id}`), { motive });
  static loadInvoiceHistory = (id: any) => agent.get(`${API_MAP.loadInvoiceHistory}`.replace('{id}', `${id}`));
  static addAffiliateInvoice = (invoiceId: number, email: string) =>
    agent.put(`${API_MAP.addAffiliateInvoice}`.replace('{invoice_id}', `${invoiceId}`), { affiliate_email: email });
  static loadProductAccess = (invoiceId: number) => agent.get(`${API_MAP.listProductAccess}`.replace('{invoice_id}', `${invoiceId}`));
  static loadHistoryAccess = (invoiceId: number) => agent.get(`${API_MAP.listAccessHistory}`.replace('{invoice_id}', `${invoiceId}`));
  static sendBoleto = (invoiceId: number) => agent.post(`${API_MAP.sendBoleto}`.replace('{invoice_id}', `${invoiceId}`), {});
  static delivery = (invoiceId: number) => agent.post(`${API_MAP.invoiceDelivery}`.replace('{invoice_id}', `${invoiceId}`), {});
  static loadPins = (invoiceId: number) => agent.get(`${API_MAP.listPinsByInvoiceId}`.replace('{invoice_id}', `${invoiceId}`));
  static downloadRefundReceipt = (invoiceId: number) =>
    agent.get<{ url: string }>(`${API_MAP.downloadRefundReceipt}`.replace('{invoice_id}', `${invoiceId}`));
  static partialRefundInvoice = (invoiceId: number, description: string, amount: number) =>
    agent.post(`${API_MAP.partialRefundInvoice}`.replace('{invoice_id}', `${invoiceId}`), {
      type: 'parcial',
      amount: `${amount}`,
      description: `${description}`,
    });
}
export default InvoiceService;
